export default __webpack_public_path__ + "static/media/chocomugcake.1e718f47.jpg";